import { ExtensionSlot, PageComponentProps } from 'piral-core'
import { Sidebar } from 'react-pro-sidebar';
import { Menu } from 'piral';
import * as React from 'react'
import './ModuleLayout.scss'
import { SearchInput } from 'piral-search';
import SearchMenu from '../components/SearchMenu';
import PageLayout from './PageLayout';
import { useTheme } from '../theming';

const sidebarCollapsedKey = 't-ml-sidebar-collapsed';
const sidebarToggledKey = 't-ml-sidebar-toggled';

export default function ModuleLayout(props: PageComponentProps) {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(localStorage.getItem(sidebarCollapsedKey) ?? false)
    const [isSidebarToggled, setIsSidebarToggled] = React.useState(localStorage.getItem(sidebarToggledKey) ?? false)
    const [theme, setTheme] = useTheme()

    React.useEffect(() => {
        localStorage.setItem(sidebarCollapsedKey, isSidebarCollapsed.toString())
        localStorage.setItem(sidebarToggledKey, isSidebarToggled.toString())
    }, [isSidebarCollapsed, isSidebarToggled])

    return (
        <div className='module-layout'>
            <ExtensionSlot name='module-extension'></ExtensionSlot>
            <sp-top-nav quiet>
                <sp-action-button quiet onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}>
                    <sp-icon-show-menu slot='icon'></sp-icon-show-menu>
                </sp-action-button>
                <sp-action-button quiet disabled>
                    <div className='logo'>
                        <t-logo compact={['S', 'M'].includes(theme.screen) ? true : undefined} dark={theme.color === 'dark' ? true : undefined} style={{ width: theme.color === 'dark' ? '24px' : 'auto' }}></t-logo>
                    </div>
                </sp-action-button>
                <div className='module-header-slot'>
                    <ExtensionSlot name='module-header'></ExtensionSlot>
                </div>
                <div flex-layout='' flex-gap=''>
                    <Menu type='header'></Menu>
                </div>
            </sp-top-nav>
            <div className='main-container'>
                <Sidebar collapsed={isSidebarCollapsed} toggled={isSidebarToggled} backgroundColor='transparent' collapsedWidth='0px'>
                    <Menu type='general'></Menu>
                </Sidebar>
                <main>
                    <PageLayout {...props}></PageLayout>
                </main>
            </div>
        </div>
    )
}
